import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://ecvdsyezeauzidjqmpyc.supabase.co";
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseKey) {
  console.error("Supabase API key is missing! Please set REACT_APP_SUPABASE_KEY in your environment.");
}

const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
